import { requestWithToken as request } from "./api";

export const getAll = (data = {}, queryParams = "") => {
    if (queryParams) {
        queryParams = `&${queryParams}`;
    }
    return request.get(`/tax_document/?format=json${queryParams}`, data);
};

/**
 *
 *

 * @param {{
    document_number: string,
    emitted_at: string,
    payment_period: number
    document_type: string,
    amount: number,
    counterpart: {
      rut: string,
      name: string,
    },
  }
}
 * }data
 * @returns {Promise<AxiosResponse<any>>}
 */

export const create = (data = {}) =>
    request.post("/tax_document/?format=json", data);

export const updatePartial = (data = {}) =>
    request.patch(`/tax_document/${data.id}/?format=json`, data.field);

export const deleteItem = (id = Number) =>
    request.delete(`/tax_document/${id}/`);

export const operationSum = (document_type = String) =>
    request.get(
        `/tax_document/operation/sum/?document_type=${document_type}&format=json`
    );

export const getOblTypesList = () =>
    request.get(`/obligation_type/?format=json`);
